/**
 * Редьюсер мазка кистью. Мазок живёт строго в пределах одной строки:
 * уход курсора на другую строку игнорируется, строка фиксируется в момент нажатия.
 * Прямоугольного выделения по нескольким сотрудникам нет.
 */

export type StrokeState =
  | { kind: "idle" }
  | { kind: "painting"; staffId: number; anchorIdx: number; hoverIdx: number }

export type StrokeEvent =
  | { type: "down"; staffId: number; colIdx: number }
  | { type: "enter"; staffId: number; colIdx: number }
  | { type: "up" }
  | { type: "cancel" }

export interface StrokeCommit {
  staffId: number
  fromIdx: number
  toIdx: number
}

export interface StrokeResult {
  state: StrokeState
  commit?: StrokeCommit
}

const rangeOf = (anchorIdx: number, hoverIdx: number) => ({
  fromIdx: Math.min(anchorIdx, hoverIdx),
  toIdx: Math.max(anchorIdx, hoverIdx),
})

export const strokeReducer = (
  state: StrokeState,
  event: StrokeEvent,
): StrokeResult => {
  switch (event.type) {
    case "down":
      return {
        state: {
          kind: "painting",
          staffId: event.staffId,
          anchorIdx: event.colIdx,
          hoverIdx: event.colIdx,
        },
      }
    case "enter":
      if (state.kind !== "painting" || state.staffId !== event.staffId) {
        return { state }
      }
      return { state: { ...state, hoverIdx: event.colIdx } }
    case "up": {
      if (state.kind !== "painting") return { state }
      return {
        state: { kind: "idle" },
        commit: {
          staffId: state.staffId,
          ...rangeOf(state.anchorIdx, state.hoverIdx),
        },
      }
    }
    case "cancel":
      return { state: { kind: "idle" } }
  }
}

/** Превью мазка для подсветки диапазона — не-null ровно у одной строки. */
export const strokeRange = (
  state: StrokeState,
): { fromIdx: number; toIdx: number } | null =>
  state.kind === "painting" ? rangeOf(state.anchorIdx, state.hoverIdx) : null
